import Lenis from 'lenis'
import * as bootstrap from 'bootstrap'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import "./swiperHandler";
import {Autoplay, EffectFade, Navigation, Pagination, Scrollbar} from 'swiper/modules';
import scrollObserver from "./scrollObserver";
import Swiper from 'swiper';
import {register} from 'swiper/element/bundle';
import 'swiper/css';
import parallaxCols from "./parallaxCols.js";
import {circleCarousel} from "./alpine/circleCarousel.js";
import {tabsCarousel} from "./alpine/tabsCarousel.js";
import {carouselModal} from "./alpine/modalCarousel.js";
import {welcomeModal} from "./alpine/welcomeModal.js";
import {complianceMenuGrid} from "./alpine/complianceMenu.js";
import breadcrumbsStack from "./breadcrumbsStack.js";
import hero from "./hero.js"
import {moveElementBottom, startPageOnTop} from "./utilities.js";
import heroHome from "./heroHome.js";
import verticalSlider from "./verticalSlider.js";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
register();

window.Alpine = Alpine
window.gsap = gsap;
window.bootstrap = bootstrap

window.circleCarousel = circleCarousel
window.tabsCarousel = tabsCarousel
window.carouselModal = carouselModal
window.welcomeModal = welcomeModal
window.complianceMenuGrid = complianceMenuGrid

Alpine.plugin(collapse)
Alpine.start()

document.addEventListener('DOMContentLoaded', async () => {
    startPageOnTop();

    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    window.lenis = lenis

    lenis.on('scroll', (e) => {
        if (e.scroll <= 20) {
            document.body.removeAttribute('data-scroll-direction')
            return
        }

        if (e.direction === 1) {
            document.body.dataset.scrollDirection = 'down'
        } else if (e.direction === -1) {
            document.body.dataset.scrollDirection = 'up'
        }
    })

    /**
     * Set 1dvh
     */
    const dvh = window.innerHeight / 100;
    document.documentElement.style.setProperty('--dvh', `${dvh}px`);

    /**
     * Move element to bottom
     */
    moveElementBottom()

    /**
     * Dynamic import gsap
     */
    // const needGsap = document.querySelector('.has-gsap') !== null;
    //
    // if (needGsap) {
    //     const {gsap} = await import('gsap');
    //     const {ScrollTrigger} = await import("gsap/ScrollTrigger");
    //     gsap.registerPlugin(ScrollTrigger);
    //     window.gsap = gsap;
    // }

    /**
     * Parallax Cols
     */
    const hasParallaxCols = document.querySelector('.parallax-cols');
    if (hasParallaxCols) parallaxCols()

    /**
     * Scroll reveal
     */
    const scrollRevealItems = document.querySelectorAll('.scroll-reveal');
    if (scrollRevealItems?.length) {
        scrollObserver({items: scrollRevealItems})
    }
    const slideUpItems = document.querySelectorAll('*:has(>.slide-up)');
    if (slideUpItems?.length) scrollObserver({items: slideUpItems, targetClass: 'is-visible'})

    /**
     * Hero
     */
    const heroEl = document.querySelector('.hero');
    if (heroEl) hero(heroEl)

    /**
     * Hero Homepage
     */
    heroHome();

    /**
     * Vertical slider
     */
    verticalSlider();

    /**
     * Accordion single gioco
     */
    const isGamePage = document.querySelector('body.single-gioco');
    if (isGamePage) {
        const accordionItems = document.querySelectorAll('.faq-accordion');
        if (!accordionItems.length) return;

        accordionItems.forEach(a => {
            a.addEventListener('shown.bs.collapse', event => {
                const y = event.target.getBoundingClientRect().top + window.scrollY - 174;
                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            })
        })
    }


    document.querySelectorAll('.form-upload').forEach(function (uploadBox) {
        const realInput = uploadBox.querySelector('input[type="file"]');
        const fakeBox = uploadBox.querySelector('.form-upload__fake');
        const button = uploadBox.querySelector('.form-upload__btn');
        const inner = uploadBox.querySelector('.form-upload__inner');
        const fileName = uploadBox.querySelector('.form-upload__filename');

        if (!realInput) return;

        const openFileDialog = function () {
            realInput.click();
        };

        fakeBox.addEventListener('click', openFileDialog);
        button.addEventListener('click', openFileDialog);

        realInput.addEventListener('change', function () {
            if (realInput.files && realInput.files.length > 0) {
                inner.classList.add('file-loaded')
                fileName.textContent = realInput.files[0].name;
            } else {
                fileName.textContent = 'Seleziona file';
            }
        });
    });

    /**
     * Category Compliance
     */
    const categoryCompliance = document.querySelector('.category-compliance');
    if (categoryCompliance) {
        breadcrumbsStack();

        import("./categoryCompliance").then(module => {
            module.default();
        });
    }
})